/**
 * ページトップへ戻るボタン制御モジュール
 *
 * - スクロール位置に応じてボタンの表示/非表示を切り替え
 * - フッター重なり時はボタン位置を自動調整
 * - クリックでスムースにページトップへ移動
 *
 * @example
 *   const toTop = new ToTopButton();
 *   toTop.init();
 *
 * 注意:
 * - #toTop, #footer のID要素が必要
 * - SP/PCでボタンの固定位置が異なる
 */
export class ToTopButton {
	constructor() {
		this.toTop = document.getElementById('toTop');
		this.footer = document.getElementById('footer');
	}

	/**
	 * 初期化処理。イベント登録と初期表示制御
	 */
	init() {
		if (!this.toTop) return;
		window.addEventListener('scroll', () => this.update());
		window.addEventListener('load', () => this.update());
		this.toTop.querySelector('a')?.addEventListener('click', this.scrollToTop);
	}

	/**
	 * ボタンクリック時にページトップへスムーススクロール
	 * @param {Event} e クリックイベント
	 */
	scrollToTop(e) {
		e.preventDefault();
		window.scrollTo({ top: 0, behavior: 'smooth' });
	}

	/**
	 * スクロール・リサイズ時にボタンの表示/位置を制御
	 */
	update() {
		const scroll = window.scrollY;
		const wH = window.innerHeight;
		const fixedPosition = window.innerWidth <= 767 ? 90 : 10;

		if (scroll >= 200) {
			this.toTop.classList.add('slideU');
			this.toTop.classList.remove('slideD');
		} else {
			this.toTop.classList.remove('slideU');
			this.toTop.classList.add('slideD');
		}

		const toTopHeight = this.toTop.offsetHeight;
		const footerPos =
			this.footer?.getBoundingClientRect().top + scroll + toTopHeight / 2;
		if (!footerPos) return;

		if (scroll + wH >= footerPos + fixedPosition) {
			const pos = scroll + wH - footerPos;
			this.toTop.style.bottom = `${pos}px`;
		} else {
			if (this.toTop.classList.contains('slideU')) {
				this.toTop.style.bottom = `${fixedPosition}px`;
			}
		}
	}
}
